const Button = ({
  type = "button",
  onClick,
  disabled = false,
  variant = "primary",
  children,
}) => {
  const buttonStyle =
    variant === "primary" ? "app-ai-quote-submit-button-primary" : "";
  const disabledStyle = disabled ? "app-ai-quote-submit-button-disabled" : "";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`app-ai-quote-submit-button ${buttonStyle} ${disabledStyle}`}
    >
      {children}
    </button>
  );
};

export default Button;
